// Set API base URL
export const API_BASE_URL = process.env.API_BASE_URL || '';



// WEBPACK FOOTER //
// ./src/utils/constants.js